module.exports = __webpack_public_path__ + "img/head.2e9ca52c.jpg";